import React, { useState, useMemo, useCallback } from 'react';
import debounce from 'lodash/debounce';
import { TextInput, TextInputProps } from '@paypalcorp/pp-react';

interface DebouncedInputProps extends TextInputProps {
  initialValue: string;
  minValue: number;
  waitTime: number;
}

const DebouncedTextInput: React.FC<DebouncedInputProps> = ({
  className = '',
  label = '',
  initialValue = '',
  type = 'number',
  onClick = () => {},
  onChange = () => {},
  name = '',
  waitTime = 1000,
  minValue = 1,
  id
}) => {
  const [value, setValue] = useState(initialValue);

  const debouncedOnChange = useMemo(
    () => debounce((targetValue) => onChange(targetValue), waitTime),
    [onChange]
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const targetValue = e?.target?.value;
      if (type !== 'number' || Number(e.target.value) >= minValue) {
        setValue(targetValue);
        debouncedOnChange(targetValue);
      }
    },
    [debouncedOnChange]
  );

  return (
    <TextInput
      id={id}
      className={className}
      label={label}
      name={name}
      value={value}
      type={type}
      onClick={onClick}
      onChange={handleChange}
    />
  );
};

export default DebouncedTextInput;
